export interface ActionWithAuthorization {
  name: string;
  icon: string;
  title: string;
  url: string;
  isFreeAction?: boolean;
  authorizationNeeded: string[];
}

class KeycloakState {
  keycloak: Keycloak.KeycloakInstance | null;
  authenticated: boolean;
  statusIconAndMessage: [string, string];

  constructor(keycloak: Keycloak.KeycloakInstance | null, authenticated: boolean, statusIconAndMessage: [string, string] | null) {
    this.keycloak = keycloak;
    this.authenticated = authenticated;
    this.statusIconAndMessage = statusIconAndMessage ?? ['lock', 'Preparing to Authenticate...'];
  }

  isAuthorized(rolesAllowed: string[]) {
    return rolesAllowed.some((role) => this.keycloak?.hasRealmRole(role));
  }

  getActionsAllowed(actions: ActionWithAuthorization[]) {
    return actions.filter((element) => this.isAuthorized(element.authorizationNeeded));
  }
};

export default KeycloakState
